import styled from 'styled-components'

import { DASHBOARD_STYLED_CONSTS } from '@components/common'
import { mediaQueries } from '@fourthwall/components'

export const Stat = styled.div`
  scroll-snap-align: start end;
  border-radius: var(--radius-brand);
  border: 1px solid var(--border-secondary);

  &:last-child {
    padding-right: ${DASHBOARD_STYLED_CONSTS.CONTENT_PADDING_HORIZONTAL}px;

    ${mediaQueries.tablet} {
      padding-right: 0;
    }
  }
`

export const DropdownContent = styled.div`
  min-width: 240px;
`
